import { Box } from "@mui/material";
import React from "react";

import CompareView from "../components/Compare/CompareView";
import EdgeDetailOverlay from "../components/Layout/EdgeDetailOverlay";
import EntityDetailOverlay from "../components/Layout/EntityDetailOverlay";
import Sidebar from "../components/Layout/Sidebar";
import { useEntityOverlay } from "../components/Layout/useEntityOverlay";

const ComparePage: React.FC = () => {
  // The detail open beside the comparison: its id and type are in the
  // address, beside the comparison's own state, which stays as it is
  const {
    detail,
    open,
    close,
    relationshipId,
    closeRelationship,
    handlePageClick,
  } = useEntityOverlay();

  return (
    <Box
      sx={{
        display: "flex",
        height: "100vh",
        backgroundColor: "background.default",
        overflow: "hidden",
      }}
      onClick={handlePageClick}
    >
      <Sidebar />
      {/* Positioned, so that the detail overlay can lie over this part */}
      <Box sx={{ flex: 1, minWidth: 0, height: "100%", position: "relative" }}>
        <CompareView onOpenEntity={open} />

        {/* The detail of the entity the address names, of whatever type */}
        {detail && (
          <EntityDetailOverlay
            entityId={detail.entityId}
            entityType={detail.entityType}
            onClose={close}
            onEntityClick={open}
          />
        )}

        {/* The relationship opened from an entity's relation table */}
        {relationshipId && (
          <EdgeDetailOverlay
            relationshipId={relationshipId}
            onClose={closeRelationship}
            onEntityClick={open}
          />
        )}
      </Box>
    </Box>
  );
};

export default ComparePage;
